import ContactPage, { handle } from '@modules/professional/page/ContactPage';
import { loader } from '@modules/professional/page/loaders/contact-page-loader.server';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';

export { loader, handle };
export const shouldRevalidate = shouldRevalidateLeaf;
export default ContactPage;
